import { foretagEntry } from "./2026-05-06-foretag"
import { welcomeEntry } from "./2026-05-06-welcome"
import { kalenderHelgdagarNoteringarEntry } from "./2026-05-07-kalender-helgdagar-noteringar"
import { vantarPaDelEntry } from "./2026-05-07-vantar-pa-del"
import { autoLevereradeLeveranserEntry } from "./2026-05-13-auto-levererade-leveranser"
import { bedomningskortRedesignEntry } from "./2026-05-13-bedomningskort-redesign"
import { filerPaJobbEntry } from "./2026-05-13-filer-pa-jobb"
import { snabbAtgardsinmatningEntry } from "./2026-05-13-snabb-atgardsinmatning"
import { veckonummerManadsvyEntry } from "./2026-05-13-veckonummer-manadsvy"
import { gammalTillaggsorderBorttagenEntry } from "./2026-05-14-gammal-tillaggsorder-borttagen"
import { onboardingEntry } from "./2026-05-24-onboarding"
import { kommentarshistorikBesiktningEntry } from "./2026-06-10-kommentarshistorik-besiktning"
import { kommentarshistorikTillaggsorderEntry } from "./2026-06-12-kommentarshistorik-tillaggsorder"
import { atgarderHeterAttGoraEntry } from "./2026-06-23-atgarder-heter-att-gora"
import { beroendenTillaggsorderEntry } from "./2026-07-09-beroenden-tillaggsorder"
import { obligatoriskaAtgarderEntry } from "./2026-07-09-obligatoriska-atgarder"
import { angraSkickatMeddelandeEntry } from "./2026-08-26-angra-skickat-meddelande"
import { egnaMeddelandemallarEntry } from "./2026-08-26-egna-meddelandemallar"
import { helaMeddelandetSomSmsEntry } from "./2026-08-27-hela-meddelandet-som-sms"
import { namedInspectionOrdersEntry } from "./2026-09-26-named-inspection-orders"
import { allJobsTableEntry } from "./2026-09-29-all-jobs-table"
import { newNavigationEntry } from "./2026-10-01-new-navigation"
import { allJobsOwnPageEntry } from "./2026-10-05-all-jobs-own-page"
import { discountInKrOrNewPriceEntry } from "./2026-10-06-discount-in-kr-or-new-price"
import { oneAccountPerPersonEntry } from "./2026-10-06-one-account-per-person"
import { englishLanguageEntry } from "./2026-10-19-english-language"
import { ungradedComponentsAndUrgencyEntry } from "./2026-10-19-ungraded-components-and-urgency"
import { automaticPickupRemindersEntry } from "./2026-10-22-automatic-pickup-reminders"
import { fullApprovalDiscountEntry } from "./2026-10-22-full-approval-discount"
import { tireHotelEntry } from "./2026-10-28-tire-hotel"
import { dropInAndBookingInPlusMenuEntry } from "./2026-10-29-drop-in-and-booking-in-plus-menu"
import { workTimeEstimateEntry } from "./2026-10-29-work-time-estimate"
import { cargoBikesAndTrikesEntry } from "./2026-11-04-cargo-bikes-and-trikes"
import { JuloUpdateEntry } from "./types"

// Newest first — that's the order mechanics see them in the feed. Add new
// entries at the top of this array.
export const juloUpdateEntries: JuloUpdateEntry[] = [
  cargoBikesAndTrikesEntry,
  workTimeEstimateEntry,
  dropInAndBookingInPlusMenuEntry,
  tireHotelEntry,
  automaticPickupRemindersEntry,
  fullApprovalDiscountEntry,
  ungradedComponentsAndUrgencyEntry,
  englishLanguageEntry,
  discountInKrOrNewPriceEntry,
  oneAccountPerPersonEntry,
  allJobsOwnPageEntry,
  newNavigationEntry,
  allJobsTableEntry,
  namedInspectionOrdersEntry,
  helaMeddelandetSomSmsEntry,
  angraSkickatMeddelandeEntry,
  egnaMeddelandemallarEntry,
  obligatoriskaAtgarderEntry,
  beroendenTillaggsorderEntry,
  atgarderHeterAttGoraEntry,
  kommentarshistorikTillaggsorderEntry,
  kommentarshistorikBesiktningEntry,
  onboardingEntry,
  gammalTillaggsorderBorttagenEntry,
  bedomningskortRedesignEntry,
  filerPaJobbEntry,
  autoLevereradeLeveranserEntry,
  snabbAtgardsinmatningEntry,
  veckonummerManadsvyEntry,
  kalenderHelgdagarNoteringarEntry,
  vantarPaDelEntry,
  foretagEntry,
  welcomeEntry,
]

export type { JuloUpdateEntry } from "./types"
